export * from './generated/supported-regions.plk';
